import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { auditData } from '../../store/AuditLog/actionCreator'
import { CircularProgress, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import HeaderTitle from '../Header/HeaderTitle'
import { Helmet } from 'react-helmet'
import { displayReadableTime } from '../../services/displayReadableTime'
import AuditDetailsItem from '../AuditLog/AuditDetailsItem'
import SelectTimezoneItem from '../ReportingPage/SelectTimezoneItem'
import { setTimezoneData } from '../../store/ReportJobs/actionCreator'
import PropTypes from 'prop-types'
import { useOutletContext } from 'react-router-dom'

function withOutletContext(WrappedComponent) {
  return function WrapperComponent(props) {
    const outletContext = useOutletContext()
    return <WrappedComponent {...props} outletContext={outletContext} />
  }
}

const styles = (theme) => ({
  spinner: {
    color: theme.palette.primary.main,
  },
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
})

export class AuditDetailsTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      blossomID: '',
      headerTitle: '',
      page: 0,
      pageSize: 10,
      timezoneDataFromChild: '',
    }
  }

  setTitle(blossomID) {
    let myTitle = ''
    if (blossomID === 'bcp') {
      myTitle = myTitle + 'BCP Audit Log Details'
    } else if (blossomID === 'c3alert') {
      myTitle = myTitle + 'C3 Audit Log Details'
    } else if (blossomID === 'ceebackup') {
      myTitle = myTitle + 'CEE Backup Audit Log Details'
    } else if (blossomID === 'fmocdc') {
      myTitle = myTitle + 'FMOC DC Audit Log Details'
    } else if (blossomID === 'precall') {
      myTitle = myTitle + 'Product Recall Audit Log Details'
    } else if (blossomID === 'CI00598283') {
      myTitle = myTitle + 'HR Audit Log Details'
    } else if (blossomID === 'c3aalert') {
      myTitle = myTitle + 'C3A Audit Log Details'
    } else if (blossomID === 'developer') {
      myTitle = myTitle + 'Developer Audit Log Details'
    } else if (blossomID === 'shipt') {
      myTitle = myTitle + 'Shipt Audit Log Details'
    }
    return myTitle
  }

  UNSAFE_componentWillMount() {
    const { outletContext, blossomIDFromParent, timezoneData } = this.props

    if (outletContext) {
      this.setState({
        blossomID: blossomIDFromParent,
        headerTitle: this.setTitle(blossomIDFromParent),
        timezoneDataFromChild: timezoneData,
        page: 0,
        pageSize: 10,
      })

      this.setAuditData(blossomIDFromParent, 0, 10)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps
    // method to see if the reports need to be refreshed
    if (
      location &&
      nextLocation &&
      nextLocation.pathname &&
      location.pathname &&
      nextLocation.pathname !== location.pathname
    ) {
      this.setState({
        blossomID: nextProps.blossomIDFromParent,
        headerTitle: this.setTitle(nextProps.blossomIDFromParent),
        page: this.pageDataCallback(),
      })
      this.setAuditData(nextProps.blossomIDFromParent, 0, 10)
    }
  }

  componentDidUpdate(prevProps) {
    const { outletContext, blossomIDFromParent, timezoneData } = this.props

    if (
      outletContext &&
      (blossomIDFromParent !== prevProps.blossomIDFromParent ||
        timezoneData !== prevProps.timezoneData)
    ) {
      this.setState({
        blossomID: blossomIDFromParent,
        headerTitle: this.setTitle(blossomIDFromParent),
        timezoneDataFromChild: timezoneData,
        page: 0,
        pageSize: 10,
      })

      this.setAuditData(blossomIDFromParent, 0, 10)
    }
  }

  // updating the returned data in an ummutable safe method.  Mostly to make it human readable
  scrubData(jsonList) {
    var newData1 = jsonList.map((el) => {
      if (el.timestamp !== 'None') {
        return Object.assign({}, el, {
          timestamp: displayReadableTime(el.timestamp, this.props.timezoneData),
        })
      }
      return el
    })
    return newData1
  }
  setAuditData(blossomID, page, pageSize) {
    this.props.auditData(blossomID, page, pageSize)
  }

  timezoneDataCallback = (dataFromChild) => {
    this.setState({ timezoneDataFromChild: dataFromChild })
  }

  auditDataCallback = (
    blossomIDFromChild,
    pageFromChild,
    pageSizeFromChild,
  ) => {
    this.setAuditData(blossomIDFromChild, pageFromChild, pageSizeFromChild)
  }

  pageDataCallback = (page) => {
    this.setState({ page: page })
  }

  pageSizeDataCallback = (pageSize) => {
    this.setState({ pageSize: pageSize })
  }

  static defaultProps = {}
  render() {
    const {
      classes,
      headerTitle,
      fetchingState,
      auditData,
      auditDataFetchingState,
      auditTableData,
    } = this.props
    let tempTitle =
      'T.O.M. - Target Outreach Manager - ' + this.state.headerTitle
    let groupTitle = <HeaderTitle title={tempTitle} />

    // Create variables from values of matching keys
    let toRender = <br />
    if (fetchingState === false && auditData === null) {
      toRender = (
        <div className={classes.centerDiv}>
          <Typography component="span" variant="h6">
            Audit Data Not Available, Try Again in 30 Seconds
          </Typography>
        </div>
      )
    } else if (fetchingState === true) {
      toRender = (
        <div className={classes.centerDiv}>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>loading...</h3>
        </div>
      )
    } else if (auditTableData != null) {
      toRender = (
        <div>
          <div>
            <SelectTimezoneItem
              callbackFromParentTimezone={this.timezoneDataCallback}
              timezoneFromParent={this.state.timezoneDataFromChild}
            />
          </div>
          <AuditDetailsItem
            blossomIDFromParent={this.state.blossomID}
            auditDataFromParent={auditTableData}
            callbackFromParentAuditData={this.auditDataCallback}
            timezoneDataFromParent={this.state.timezoneDataFromChild}
            pageFromParent={this.state.page}
            pageSizeFromParent={this.state.pageSize}
            callbackFromParentPage={this.pageDataCallback}
            callbackFromParentPageSize={this.pageSizeDataCallback}
            fetchingState={auditDataFetchingState}
          />
        </div>
      )
    }

    return (
      <div>
        {groupTitle}
        <Helmet>
          <title>{headerTitle}</title>
        </Helmet>
        {toRender}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      auditData,
      setTimezoneData,
    },
    dispatch,
  )

const mapStateToProps = (state) => ({
  auditTableData: state.auditDetails.data,
  fetchingState: state.auditDetails.auditDataFetching,
  timezoneData: state.reportJobs.timezoneData,
})

const AuditDetailsTableWithContext = withOutletContext(AuditDetailsTable)
const StyledConnectedAuditDetailsTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(AuditDetailsTableWithContext))

export default StyledConnectedAuditDetailsTable

AuditDetailsTable.propTypes = {
  blossomIDFromParent: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  timezoneData: PropTypes.string,
  auditData: PropTypes.func.isRequired,
  headerTitle: PropTypes.string,
  classes: PropTypes.object,
  fetchingState: PropTypes.bool,
  auditTableData: PropTypes.shape({
    total_entries_available: PropTypes.number,
    audit_data: PropTypes.arrayOf(
      PropTypes.shape({
        timestamp: PropTypes.string,
        requested_by_id: PropTypes.string,
        action: PropTypes.string,
        previous_state: PropTypes.string,
        requested_state: PropTypes.string,
      }),
    ),
  }),
  auditDataFetchingState: PropTypes.bool,
}
